import { useRef, useState } from "react";
import useGreenOneSdxStyles from "../../hooks/useGreenOneSdxStyles";
import {
  subscribeToMailingList,
  validateMailingListEntry,
} from "../../utils/mailingList";
import "./mailinglist.css";

export default function MailingListForm() {
  const containerRef = useRef(null);
  const [company, setCompany] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [hasConsent, setHasConsent] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const submitPending = useRef(false);

  useGreenOneSdxStyles(containerRef);

  function clearError(field) {
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (submitPending.current) return;

    const nextErrors = validateMailingListEntry({
      company,
      name,
      email,
      hasConsent,
    });
    setErrors(nextErrors);
    setSubmitError(null);
    if (Object.keys(nextErrors).length > 0) return;

    submitPending.current = true;
    setIsSubmitting(true);
    try {
      await subscribeToMailingList({ company, name, email });
      setIsSubscribed(true);
    } catch (err) {
      console.error("Mailinglisten-Anmeldung fehlgeschlagen:", err);
      setSubmitError(
        "Die Anmeldung hat leider nicht geklappt. Bitte versuchen Sie es später erneut."
      );
    } finally {
      submitPending.current = false;
      setIsSubmitting(false);
    }
  }

  return (
    <div ref={containerRef} className="ml-card">
      {isSubscribed ? (
        <div role="status">
          <h2 className="ml-title">Vielen Dank!</h2>
          <p className="ml-lead">
            Ihre Voranmeldung als First Mover ist bei uns eingegangen.
          </p>
        </div>
      ) : (
        <>
          <h2 className="ml-title">First Mover Voranmeldung</h2>
          <p className="ml-lead">
            Mit dieser Registration erhalten Sie als First Mover von uns den
            kostenlosen Zugang zu GreenOne, sobald die Plattform online geht.
          </p>

          <form className="ml-form" onSubmit={handleSubmit} noValidate>
            <sdx-input
              label="Firma"
              placeholder="Geben Sie Ihre Firma ein"
              name="company"
              value={company}
              onInput={(e) => {
                setCompany(e.target.value);
                clearError("company");
              }}
              valid={errors.company ? false : undefined}
              validation-message={errors.company}
              required
            ></sdx-input>

            <sdx-input
              label="Name"
              placeholder="Geben Sie Ihren Namen ein"
              name="name"
              value={name}
              onInput={(e) => {
                setName(e.target.value);
                clearError("name");
              }}
              valid={errors.name ? false : undefined}
              validation-message={errors.name}
              clarity-mask="True"
              required
            ></sdx-input>

            <sdx-input
              label="E-Mail"
              type="email"
              inputmode="email"
              placeholder="Geben Sie Ihre E-Mail ein"
              name="email"
              value={email}
              onInput={(e) => {
                setEmail(e.target.value);
                clearError("email");
              }}
              valid={errors.email ? false : undefined}
              validation-message={errors.email}
              clarity-mask="True"
              required
            ></sdx-input>


            <label className="ml-consent">
              <input
                type="checkbox"
                checked={hasConsent}
                onChange={(e) => {
                  setHasConsent(e.target.checked);
                  clearError("consent");
                }}
              />
              Ich bestätige hiermit, dass Swisscom mich für die Registration
              auf GreenOne kontaktieren darf.
            </label>

            {(errors.consent || submitError) && (
              <p className="ml-error" role="alert">
                {errors.consent || submitError}
              </p>
            )}

            <sdx-button
              type="submit"
              variant="primary"
              label="Anmelden"
              loading={isSubmitting}
              disabled={isSubmitting}
            ></sdx-button>
          </form>
        </>
      )}
    </div>
  );
}
